export type SearchParamsType = {
  filter: {
    searchText: string;
    status: number;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  deptName: string;
  clinicId: number;
  isExternalRef: boolean;
  deptId: number;
  skipVitals: boolean;
  createdByDate: string;
  isRefRequired: boolean;
  deptCode: string;
  deptStatus: number;
  createdById: number;
};

export type MasterDataType = {
  deptId: number | null;
  deptCode: string;
  deptName: string;
  deptStatus: number;
  skipVitals: boolean;
  createdById: number;
  clinicId: number;
  createdByDate: string;
  refRequired: boolean;
  externalRef: boolean;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  deptCode: string;
  deptName: string;
  deptStatus: number;
  skipVitals: boolean;
  refRequired: boolean;
  externalRef: boolean;
};

export const initialFormData: MasterFormDataType = {
  deptCode: "",
  deptName: "",
  skipVitals: false,
  refRequired: false,
  externalRef: false,
  deptStatus: 1,
};
